export default {
  siteId: "4",
  siteName: "es",
  site: "ESPAÑA",
  lang: "Spanish",
  langCode: "es-ES",
  activityName: "",
  productList: "Lista de productos",
  POST: "PUBLICACIÓN",
  Score: "Puntaje",
  Title: "Título",
  Review: "Resuñas",
  Media: "Medios",
  MediaType: "Los tipos de archivos admitidos incluyen JPEG, JPG, PNG o MP4.",
  MediaReward:
    "Comparte fotos o videos para desbloquear recompensas especiales.",
  RewardQa:
    "Completa todas las preguntas a continuación para obtener recompensas adicionales.",
  MoreQa: "Haz clic para completar más preguntas.",
  RewardsToast: "Su recompensa se ha acreditado correctamente en su cuenta.",
  rateLevel1: "Muy satisfecha",
  rateLevel2: "Algo satisfecha",
  rateLevel3: "Ni satisfecha ni insatisfecha",
  rateLevel4: "Algo insatisfecha",
  rateLevel5: "Muy insatisfecha",
  "LEAVE A REVIEW": "Por favor deje una reseña",
  "Please enter a star rating for this review":
    "Ingrese una calificación de estrellas para esta reseña",
  "Review’s title can’t be empty":
    "El título y el cuerpo de la reseña no pueden estar vacíos",
  "Review’s body can’t be empty":
    "El título y el cuerpo de la reseña no pueden estar vacíos",
  "Please upload a media less than 10 megabytes":
    "Sube un archivo multimedia de menos de 10 megabytes",
  "Please upload a media less than 20 megabytes":
    "Sube un archivo multimedia de menos de 20 megabytes",
  "THANK YOU FOR YOUR COMMENTS": "GRACIAS POR SUS COMENTARIOS",
  "We love seeing reviews":
    "Amamos ver reseñas - ¡gracias por publicar la suya! Siéntase libre de compartirlo para que otros puedan verlo también.",
  "fill out":
    "Por favor, rellene el siguiente formulario y envíe su reseña del sitio, se lo agradeceremos mucho.",
  "SUBMIT YOUR REVIEW": "ENVÍE SU RESEÑA",
  shopping: "https://es.cupshe.com/collections/los-mas-vendidos",
  mailto: "customercare",
  pageTitle: "Resuñas de los Clientas",
  "VIEW COMMENTS": "VEA COMENTARIOS",
  "GO SHOPPING": "VAYA DE COMPRAS",
  mailText: `Para asegurarse de que recibe nuestras actualizaciones por correo electrónico, añada <a style="color:#333;text-decoration: underline;" class="c-muli-light" href="mailto:{mailto}{domain}">{mailto}{domain}</a> a su lista de contactos.`,
  email: "Email",
  "contact us": "Contactenos",
  contactUrl: "https://es.cupshe.com/pages/contactarnos",
  chat: "chat",
  next: "siguiente",
  copyright: "Copyright © {year} CUPSHE {sitename}, Todos los derechos reservados.",
  subscribe1:
    "Ha cancelado correctamente su suscripción a los mensajes de marketing de Cupshe ES",
  subscribe2: "¿No quería darse de baja?",
  subscribe3: "RESUBSCRIBETE",
  subscribe4:
    "Te has resuscrito con éxito a los mensajes de Marketing de Cupshe ES.",
  "You're already on the list!": "¡Ya estás en la lista!",
  "Oops, there was a hiccup!Please try again.":
    "¡Oh, eructa! Por favor, inténtalo de nuevo.",
  unsubscribe: "darse de baja",
  continuesubscribe: "SEGUIR SUSCRITO",
  trustsubscribe:
    "Gracias por su confianza, le brindaremos mejores servicios y productos más asequibles.",
  mailContact:
    'Póngase en contacto con el servicio de <a href="https://es.cupshe.com/pages/contact-us" class="contact_link">atención al cliente</a> para obtener ayuda.',
  policyText:
    "*Tenga en cuenta: Después de darse de baja, es posible que reciba correos electrónicos con información contractual relativa a futuras compras en línea (confirmaciones de pedidos, notificaciones de envío, notificaciones de reembolso, etc.).",
};
